/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'

import {
  getVersion,
  getRegionId,
  getFirstEsClusterFromGet,
} from '@/lib/stackDeployments/selectors/fundamentals'
import { getDeploymentTemplateId } from '@/lib/stackDeployments/selectors/deploymentTemplates'
import { getDeploymentTemplate } from '@/reducers/deploymentTemplates'
import { enableCrossClusterReplicationRequest } from '@/reducers/asyncRequests/registry'

import { enableCrossClusterReplication } from '../../../actions/deployments/ccr'
import { fetchDeployment } from '../../../actions/stackDeployments'
import { getConfigForKey } from '../../../selectors'
import { isFeatureActivated } from '../../../store'

import EnableCrossClusterReplicationCallout from './EnableCrossClusterReplicationCallout'

import type { ReduxState, ThunkDispatch } from '@/types/redux'
import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps: (state: ReduxState, consumerProps: ConsumerProps) => StateProps = (
  state,
  { deployment },
) => {
  const esResource = getFirstEsClusterFromGet({ deployment })!
  const regionId = getRegionId({ deployment })!
  const deploymentTemplateId = getDeploymentTemplateId({ deployment })!
  const version = getVersion({ deployment })
  const { ref_id: refId } = esResource

  return {
    isCrossEnvCcsCcrActivated: isFeatureActivated(Feature.crossEnvCCSCCR),
    isEce: getConfigForKey(state, `APP_PLATFORM`) === `ece`,
    deploymentTemplate: getDeploymentTemplate(state, regionId, deploymentTemplateId, version),
    enableCrossClusterReplicationRequest: enableCrossClusterReplicationRequest(
      state,
      deployment.id,
      refId,
    ),
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  enableCrossClusterReplication: (...args) => dispatch(enableCrossClusterReplication(...args)),
  fetchDeployment: (...args) => dispatch(fetchDeployment(...args)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(EnableCrossClusterReplicationCallout)
